import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IRankingPayload {
	teamId?: number;
	page?: number;
	limit?: number;
}

export interface IRanking {
	playerId: number;
	name: string;
	firstName: string;
	lastName: string;
	squadId: number;
	squadName: string;
	awards?: number | null;
	countVotes?: number | null;
	fanAwards?: number | null;
	mediaAwards?: number | null;
}

export interface IRankingResponse {
	rankings: IRanking[];
	nextPage: boolean;
}

export type TRankingResponse = IApiResponse<IRankingResponse>;
export interface IRankingApiProvider {
	overall: (params: IRankingPayload) => Promise<AxiosResponse<TRankingResponse>>;
	team: (params: IRankingPayload) => Promise<AxiosResponse<TRankingResponse>>;
	fan: (params: IRankingPayload) => Promise<AxiosResponse<TRankingResponse>>;
}

@injectable()
export class RankingApiProvider implements IRankingApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	overall = (params: IRankingPayload) =>
		this._http.get<TRankingResponse>(`pog/ranking/leaderboard`, params);
	team = (params: IRankingPayload) =>
		this._http.get<TRankingResponse>(`pog/ranking/team_leaderboard`, params);
	fan = (params: IRankingPayload) =>
		this._http.get<TRankingResponse>(`pog/ranking/fan_leaderboard`, params);
}
